"use client";

import { FC, useRef } from "react";
import { Image as DatoImage } from "react-datocms";

import { OfficeRecord } from "@graphql/types/graphql";
import { useParallax } from "utils";

import s from "./OfficeHero.module.scss";

interface Props {
  video: NonNullable<OfficeRecord["officeVideo"]> | null | undefined;
  image: OfficeRecord["introImage"];
}

export const OfficeHeroMedia: FC<Props> = ({ video, image }) => {
  const parallaxRef = useRef<HTMLDivElement>(null);
  const parallaxY = useParallax(parallaxRef, 0.15);
  const parallaxStyle = {
    transform: `translate3d(0px, ${parallaxY}px, 0px) scale(1.05)`,
    transformOrigin: "50% 100%",
  };

  return (
    <div className={s.OfficeHeroMedia}>
      <div className={s.OfficeHeroMediaParallax} ref={parallaxRef} style={parallaxStyle}>
        {video ? (
          <video
            autoPlay
            playsInline
            muted
            loop
            className={s.OfficeHeroVideo}
            style={parallaxStyle}
          >
            <source src={video.url} type={`video/${video.format}`} />
            Your browser does not support the video tag.
          </video>
        ) : (
          <DatoImage layout="fill" objectFit="cover" data={image?.responsiveImage} />
        )}
      </div>
    </div>
  );
};
